import { render } from "./PersonAvatarComponent.vue?vue&type=template&id=1520dc9b&scoped=true&ts=true"
import script from "./PersonAvatarComponent.vue?vue&type=script&lang=ts"
export * from "./PersonAvatarComponent.vue?vue&type=script&lang=ts"

import "./PersonAvatarComponent.vue?vue&type=style&index=0&id=1520dc9b&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1520dc9b"]])

export default __exports__